<template>
    <div>
        <slot :letters="letters"></slot>
    </div>
</template>

<script>
import { defineComponent, onBeforeMount, ref, watch } from 'vue';
import { getPeople, getWorks } from '../services/inventory';
import { orderBy } from 'lodash';

export default defineComponent({
    name: 'ComposerList',
    props: {
    },
    setup(props) {
        const letters = ref([]);

        onBeforeMount(async () => {
            let [ people, works ] = await Promise.all([
                getPeople(),
                getWorks(),
            ]);

            people = people.filter(person => {
                return person.role?.trim().toLowerCase() === 'composer';
            });

            letters.value = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(letter => {
                const lowerCase = letter.toLowerCase();

                let composers = people.filter(person => {
                    const name = person.lastName ? person.lastName : person.firstName;
                    return name[0].trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() === lowerCase;
                });

                composers = composers.map(composer => {
                    composer.works = works.filter(work => {
                        return work?.attributes?.custom?.composer?.id === composer.id;
                    });

                    return composer;
                });

                return {
                    title: letter,
                    id: letter,
                    composers: orderBy(composers, [
                        composer => {
                            return (composer.firstName || '').toLowerCase();
                        },
                        composer => {
                            return (composer.lastName || '').toLowerCase();
                        },
                    ], ['asc', 'asc']),
                }
            });
        })

        return {
            letters,
        }
    },
});
</script>
